import { render, staticRenderFns } from "./wareList.vue?vue&type=template&id=c0aa6baa&"
import script from "./wareList.vue?vue&type=script&lang=js&"
export * from "./wareList.vue?vue&type=script&lang=js&"
import style0 from "./wareList.vue?vue&type=style&index=0&id=c0aa6baa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports